import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

import Alpine from "alpinejs";
import ambassadors from "./ambassadors";

function App() {}

App.prototype = {
  // -
  preload: function () {
    Fancybox.bind("[data-fancybox]", {});

    const ambassadorsEl = document.querySelector(".ambassadors");
    if (ambassadorsEl) {
      ambassadors(ambassadorsEl);
    }

    Alpine.store("engageWindow", {
      isOpen: false,
      toggle() {
        this.isOpen = !this.isOpen;
      },
      open() {
        this.isOpen = true;
      },
      close() {
        this.isOpen = false;
      },
    });

    Alpine.start();
    this.bind();
  },

  // -
  bind: function () {
    window.addEventListener("resize", this.onResize.bind(this));
  },

  // -
  showMenu: function () {},

  // -
  onResize: function () {},

  // -
  isPhone: function () {
    return document.body.classList.contains("mobile");
  },

  // -
  isTablet: function () {
    return document.body.classList.contains("tablet");
  },

  // --
  lazyLoading: function () {
    var lazyloadImages;

    if ("IntersectionObserver" in window) {
      lazyloadImages = document.querySelectorAll(".lazy");

      var imageObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var image = entry.target;
            if (image.tagName == "IMG" || image.tagName == "img") {
              image.src = image.dataset.src;
              image.srcset = image.dataset.srcset;
            } else {
              if (image.dataset.src !== undefined) {
                image.style.backgroundImage = "" + image.dataset.src + "";
              }
              if (image.dataset.srcimgset !== undefined) {
                image.style.backgroundImage = image.dataset.srcimgset;
              }
            }
            image.classList.remove("lazy");
            image.classList.add("lazy-ok");
            imageObserver.unobserve(image);

            image.dataset.src = "";
            image.dataset.srcset = "";
            image.dataset.srcimgset = "";
          }
        });
      });

      lazyloadImages.forEach(function (image) {
        imageObserver.observe(image);
      });
    } else {
      var lazyloadThrottleTimeout;
      lazyloadImages = document.querySelectorAll(".lazy");

      function lazyload() {
        if (lazyloadThrottleTimeout) {
          clearTimeout(lazyloadThrottleTimeout);
        }

        lazyloadThrottleTimeout = setTimeout(function () {
          var scrollTop = window.pageYOffset;
          lazyloadImages.forEach(function (img) {
            if (img.offsetTop < window.innerHeight + scrollTop) {
              if (img.tagName == "IMG" || img.tagName == "img") {
                img.src = img.dataset.src;
                img.srcset = img.dataset.srcset;
              } else {
                if (img.dataset.src !== undefined) {
                  img.style.backgroundImage = "'" + image.dataset.src + "";
                }
                if (img.dataset.srcimgset !== undefined) {
                  img.style.backgroundImage += img.dataset.srcimgset;
                }
              }
              img.classList.remove("lazy");
              img.dataset.src = "";
              img.dataset.srcset = "";
              img.dataset.srcimgset = "";
            }
          });
          if (lazyloadImages.length == 0) {
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
        }, 20);
      }

      document.addEventListener("scroll", lazyload);
      window.addEventListener("resize", lazyload);
      window.addEventListener("orientationChange", lazyload);
    }
  },
};

// Pour piéger webpack
window.App = App;
window.Alpine = Alpine;

// Alpine.store('scroll', {
//     value: window.scrollY,
//     direction: -1,
// })
// const store = Alpine.store('scroll')
//
// window.addEventListener('scroll', () => {
//     store.direction = Math.sign(window.scrollY - store.value)
//     store.value = window.scrollY
// })
